import { GA } from '@/api/analytics'
import { Store } from '@/store/store.class'

interface Modal {
  modelValue: boolean;
  [prop: string]: boolean | never;
}
interface StateModals {
  GetPro: Modal;
  RouteLimitExceeded: Modal;
  PrivacyConsent: Modal;
  CreateRoute: Modal;
  GiveFeedback: Modal;
  PlaceSettings: Modal;
  RouteSettings: Modal;
  PlaceImporter: Modal;
  ShareRoute: Modal;
  AssignDriver: Modal;
  Message: Modal;
  SignIn: Modal;
  PayWall: Modal;
}
interface ModalState extends Object {
  queue: string[];
  modals: StateModals;
}

class ModalStore extends Store<ModalState> {
  constructor() {
    super({
      name: 'modal',
      cached: false,
      state: {
        queue: [],
        modals: {
          GetPro: {modelValue: false},
          RouteLimitExceeded: {modelValue: false},
          PrivacyConsent: {modelValue: false},
          CreateRoute: {modelValue: false},
          GiveFeedback: {modelValue: false},
          PlaceSettings: {modelValue: false},
          RouteSettings: {modelValue: false},
          PlaceImporter: {modelValue: false},
          ShareRoute: {modelValue: false},
          AssignDriver: {modelValue: false},
          Message: {modelValue: false},
          SignIn: {modelValue: false},
          PayWall: {modelValue: false}
        }
      }
    })
  }
  showModal(modal: keyof StateModals, props?: object) {    
    this.state.modals[modal] = {modelValue: true, ...props}
    GA('modal_action', { name: modal, action_type: 'open' })
  }
  hideModal(modal: keyof StateModals) {    
    this.state.modals[modal].modelValue = false
  }
}
export const modalStore = new ModalStore()